import {createRef} from 'react';
import {RuleType} from '../../enums';
import {texts} from '../../texts';

export const automationMenuRef = createRef<HTMLButtonElement>();

export type AutomationSettingsItem = {
    title: string;
    desc: string;
    isDisabled: boolean;
    showInPopup: boolean;
    type: RuleType;
};

export const macroItem: AutomationSettingsItem = {
    title: texts.menu_macro,
    desc: texts.menu_macroHelp,
    isDisabled: false,
    showInPopup: true,
    type: RuleType.macro
};

export const getSettingsItems: () => Array<AutomationSettingsItem> = () => [
    {
        title: texts.business_rules_option_title,
        desc: texts.rules_dialog_help,
        isDisabled: false,
        showInPopup: true,
        type: RuleType.business
    },

    {
        title: texts.autofill_rules_option_title,
        desc: texts.autofill_rules_dialog_help,
        isDisabled: false,
        showInPopup: true,
        type: RuleType.autofill
    }
];
